function getGuestWishlistKey(): string {
  if (typeof window === 'undefined') return 'guest_wishlist';
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const config = require('@/lib/api-adapter/config').getCurrentConfig();
    const storeId = config?.storeId || config?.storeKey;
    return storeId ? `guest_wishlist_${storeId}` : 'guest_wishlist';
  } catch {
    return 'guest_wishlist';
  }
}

export function readGuestWishlist(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    return JSON.parse(localStorage.getItem(getGuestWishlistKey()) || '[]');
  } catch {
    return [];
  }
}

export function writeGuestWishlist(productIds: string[]): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(getGuestWishlistKey(), JSON.stringify(productIds));
}

export function clearGuestWishlist(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(getGuestWishlistKey());
}

export function addToGuestWishlist(productId: string): string[] {
  const items = readGuestWishlist();
  if (!items.includes(productId)) {
    items.push(productId);
    writeGuestWishlist(items);
  }
  return items;
}

export function removeFromGuestWishlist(productId: string): string[] {
  const items = readGuestWishlist().filter((id) => id !== productId);
  writeGuestWishlist(items);
  return items;
}

export function isInGuestWishlist(productId: string): boolean {
  return readGuestWishlist().includes(productId);
}
